module.exports = __webpack_public_path__ + "img/people-inlove.86640545.png";